<template>
  <div class="projectPage">
                    <div class="projectHeader">
                        <div class="projectTitle">
                            <div class="leftHeader">
                                <div id="projectDetailBtn" class="simpleBtn">
                                    <i class="bi bi-three-dots-vertical"></i>
                                </div>
                                <div class="projectName">
                                    <i class="bi bi-app"></i>
                                    <span>{{projectInfo.Name}}</span>
                                </div>
                            </div>
                            <div class="rightHeader">
                                <button class="grayBtn">
                                    <i class="bi bi-person-add"></i>
                                    <span>초대하기</span>
                                </button>
                            </div>
                        </div>
                        <div class="projectMenu">
                            <div id="feed" class="projectMenuItem" @click="navigateProjectMenu('feed')">피드</div>
                            <div id="task" class="projectMenuItem" @click="navigateProjectMenu('task')">업무</div>
                            <div id="calendar" class="projectMenuItem" @click="navigateProjectMenu('calendar')">캘린더</div>
                            <div id="file" class="projectMenuItem active" @click="navigateProjectMenu('file')">파일</div>
                        </div>
                    </div>
                    <div class="fileListPageContainer">
                        <div class="fileListPage">
                          <div class="fileListHeader">
                            <!-- 필터검색 : .open <-> .close -->
                            <div class="filterPanelBox close"> 
                              <div class="filterPanelContainer">
                                <div class="filterPanelHeader">
                                  <span>필터</span>
                                </div>
                                <div class="filterPanelBody">
                                  <!-- .filterPanelItemBox 클릭시 .active on/off -->
                                  <div class="filterPanelItemBox statusFilter active">
                                    <div class="filterPanelItemTitle">
                                      <span>상태</span>
                                      <i class="bi bi-chevron-up"></i>
                                    </div>
                                    <div class="filterPanelItemList">
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption1" checked>
                                        <label for="checkOption1">전체</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption2" >
                                        <label for="checkOption2">오늘</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption3" >
                                        <label for="checkOption3">7일</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption4" >
                                        <label for="checkOption4">1개월</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption5" >
                                        <label for="checkOption5">3개월</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption5" >
                                        <label for="checkOption5">6개월</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption5" >
                                        <label for="checkOption5">1년</label>
                                      </div>
                                      <div class="filterInputItem checkBoxItem">
                                        <input type="checkbox" name="statusFilter" id="checkOption5" >
                                        <label for="checkOption5">기간선택</label>
                                      </div>
                                      <!-- 기간선택 선택 시 : .active -->
                                      <div class="filterInputItem selectDate">
                                        <div><input type="date" name="" id="">부터</div>
                                        <div><input type="date" name="" id="">까지</div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="filterPanelItemBox filetypeFilter active">
                                    <div class="filterPanelItemTitle">
                                      <span>파일 유형</span>
                                    </div>
                                    <div class="filterInputItem dropdownBox">
                                      <select id="options" class="filetypeOption">
                                        <option value="1">전체</option>
                                        <option value="2">압축파일</option>
                                        <option value="3">한글</option>
                                        <option value="4">워드</option>
                                        <option value="5">파워포인트</option>
                                        <option value="6">엑셀</option>
                                        <option value="7">이미지</option>
                                        <option value="8">음악·동영상</option>
                                        <option value="9">PDF</option>
                                        <option value="10">CAD</option>
                                        <option value="11">HTML</option>
                                        <option value="11">클라우드</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="filterPanelItemBox projectListFilter active">
                                    <div class="filterPanelItemTitle">
                                      <span>프로젝트 목록</span>
                                    </div>
                                    <div class="filterPanelItemList">
                                      <div class="filterInputItem listItem groupOpen">
                                        <div class="caretBtn"><i class="bi bi-caret-down-fill"></i></div>
                                        <div class="projecListTitle">전체 프로젝트</div>
                                      </div>
                                      <div class="filterInputItem listItem groupOpen">
                                        <div class="listSpace"></div>
                                        <div class="caretBtn"><i class="bi bi-caret-down-fill"></i></div>
                                        <div class="projecListTitle">
                                          <i class="bi bi-app"></i>
                                          프로젝트명
                                        </div>
                                      </div>
                                      <div class="filterInputItem listItem ">
                                        <div class="listSpace"></div>
                                        <div class="listSpace"></div>
                                        <div class="listSpace"></div>
                                        <div class="iconImg"><img src="../../../images/fileIcon/folder.png" alt=""></div>
                                        <div class="projecListTitle">폴더명</div>
                                      </div>
                                      <div class="filterInputItem listItem groupClose">
                                        <div class="listSpace"></div>
                                        <div class="caretBtn"><i class="bi bi-caret-right-fill"></i></div>
                                        <div class="projecListTitle">
                                          <i class="bi bi-app"></i>
                                          프로젝트명
                                        </div>
                                      </div>
                                      <div class="filterInputItem listItem groupClose">
                                        <div class="listSpace"></div>
                                        <!-- <div class="caretBtn"><i class="bi bi-caret-down-fill"></i></div> -->
                                        <div class="projecListTitle">
                                          <i class="bi bi-app"></i>
                                          프로젝트명
                                        </div>
                                      </div>
                                      <div class="filterInputItem listItem groupClose">
                                        <div class="listSpace"></div>
                                        <!-- <div class="caretBtn"><i class="bi bi-caret-down-fill"></i></div> -->
                                        <div class="projecListTitle">
                                          <i class="bi bi-app"></i>
                                          프로젝트명
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="filterPanelBtn">
                                <span>필터</span>
                                <i class="bi bi-chevron-left"></i>
                              </div>  
                            </div>
                            <div class="projectListHeaderLeft">
                              <div class="projectSearch formRightIcon">
                                <input type="search" name="projectSearch" id="projectSearch" placeholder="파일명 또는 등록자를 검색해주세요">
                                <span class="formIcon">
                                  <i class="bi bi-search"></i>
                                </span>
                              </div>
                            </div>
                            <div class="projectListHeaderRight">
                              <div class="moveBtnBox">
                                <button class="biglineBtn">
                                  <i class="bi bi-reply"></i>
                                  <span>이동</span>
                                </button>
                              </div>
                              <div class="downBtnBox">
                                <button class="biglineBtn">
                                  <i class="bi bi-download"></i>
                                  <span>다운로드</span>
                                </button>
                              </div>
                              <div class="deleteBtnBox">
                                <button class="biglineBtn">
                                  <i class="bi bi-trash3"></i>
                                  <span>삭제</span>
                                </button>
                              </div>
                              <div class="addListBtnBox">
                                <button class="biglineBtn blueBtn">
                                  <i class="bi bi-plus-lg"></i>
                                  <span>폴더 추가</span>
                                </button>
                                <!-- ▼ 폴더 추가 모달. 클릭 시 class="active" 추가 -> 나타남 -->
                                <div class="modalBg createFolder">
                                  <div class="modalBox createFolderBox">
                                    <div class="modalHeader">
                                      <div class="modalTitleBox">
                                        <div class="modalTitle">
                                            <h5>폴더 추가</h5>
                                        </div>
                                        <div class="modalHeaderBtnBox">
                                            <span class="closeBtn"><i class="bi bi-x-lg"></i></span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modalBody">
                                      <input type="text" placeholder="폴더명을 입력해주세요">
                                    </div>
                                    <div class="modalFooter">
                                      <button class="lineBtn">취소</button>
                                      <button class="blueBtn">확인</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- 보기방식 변경. 그리드 <-> 리스트 : .active -->
                              <div class="toggleBtnBox">
                                <div class="gridTable ">
                                  <i class="bi bi-grid-fill"></i>
                                </div>
                                <div class="listTable active">
                                  <i class="bi bi-list"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="fileListBody active">
                            <table>
                              <thead>
                                <tr>
                                  <th>파일명</th>
                                  <th style="width: 10%;">용량</th>
                                  <th style="width: 10%;">등록자</th>
                                  <th style="width: 15%;">등록일</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/folder.png" alt="folder">
                                      </div>
                                      <div class="fileListTitle">폴더명</div>
                                    </div>
                                  </td>
                                  <td>-</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr class="selected">
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle-fill"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/file.png" alt="file">
                                      </div>
                                      <div class="fileListTitle">기타파일</div>
                                    </div>
                                  </td>
                                  <td>1.87 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr class="selected">
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle-fill"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/zip.png" alt="zip">
                                      </div>
                                      <div class="fileListTitle">압축파일</div>
                                    </div>
                                  </td>
                                  <td>11.01 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr class="selected">
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle-fill"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/hangeul.png" alt="hangeul">
                                      </div>
                                      <div class="fileListTitle">한글</div>
                                    </div>
                                  </td>
                                  <td>1.25 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/word.png" alt="word">
                                      </div>
                                      <div class="fileListTitle">워드</div>
                                    </div>
                                  </td>
                                  <td>2.42 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/excel.png" alt="excel">
                                      </div>
                                      <div class="fileListTitle">엑셀</div>
                                    </div>
                                  </td>
                                  <td>4.23 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/powerpoint.png" alt="powerpoint">
                                      </div>
                                      <div class="fileListTitle">파워포인트</div>
                                    </div>
                                  </td>
                                  <td>2.01 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/pdf.png" alt="pdf">
                                      </div>
                                      <div class="fileListTitle">PDF</div>
                                    </div>
                                  </td>
                                  <td>3.68 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/cloud.png" alt="cloud">
                                      </div>
                                      <div class="fileListTitle">클라우드</div>
                                    </div>
                                  </td>
                                  <td>8.41 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/html.png" alt="html">
                                      </div>
                                      <div class="fileListTitle">HTML</div>
                                    </div>
                                  </td>
                                  <td>23.29 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/css.png" alt="css">
                                      </div>
                                      <div class="fileListTitle">CSS</div>
                                    </div>
                                  </td>
                                  <td>2.25 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/js.png" alt="js">
                                      </div>
                                      <div class="fileListTitle">Java Script</div>
                                    </div>
                                  </td>
                                  <td>8.38 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/cad.png" alt="cad">
                                      </div>
                                      <div class="fileListTitle">CAD</div>
                                    </div>
                                  </td>
                                  <td>3.83 GB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/video.png" alt="video">
                                      </div>
                                      <div class="fileListTitle">음악 · 동영상</div>
                                    </div>
                                  </td>
                                  <td>3.38 GB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/file.png" alt="file">
                                      </div>
                                      <div class="fileListTitle">기타파일</div>
                                    </div>
                                  </td>
                                  <td>2.38 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/file.png" alt="file">
                                      </div>
                                      <div class="fileListTitle">기타파일</div>
                                    </div>
                                  </td>
                                  <td>2.38 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/file.png" alt="file">
                                      </div>
                                      <div class="fileListTitle">기타파일</div>
                                    </div>
                                  </td>
                                  <td>2.38 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="fileListTitleBox">
                                      <div class="fileListCheckBox">
                                        <i class="bi bi-check-circle"></i>
                                      </div>
                                      <div class="fileListIcon">
                                        <img src="../../../images/fileIcon/file.png" alt="file">
                                      </div>
                                      <div class="fileListTitle">기타파일</div>
                                    </div>
                                  </td>
                                  <td>2.38 MB</td>
                                  <td>홍길동</td>
                                  <td>2025-07-31 14:40</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="fileGridBody ">
                            <div class="fileGridBodyHeader orderBtnBox">
                              <div class="orderBtn">
                                <span>
                                  <span>최신 업로드 순</span>
                                  &nbsp;<i class="bi bi-caret-up-fill"></i>
                                </span>
                              </div>
                              <!-- .orderBtn 클릭시 .active -->
                              <div class="orderSelectBox ">
                                <div class="simpleBtn selected">
                                  <span>최신 업로드 순</span>
                                  <i class="bi bi-caret-up-fill"></i>
                                </div>
                                <div class="simpleBtn">
                                  <span>최신 업로드 순</span>
                                  <i class="bi bi-caret-down-fill"></i>
                                </div>
                                <div class="simpleBtn">
                                  <span>파일명 순</span>
                                  <i class="bi bi-caret-up-fill"></i>
                                </div>
                                <div class="simpleBtn">
                                  <span>파일명 순</span>
                                  <i class="bi bi-caret-down-fill"></i>
                                </div>
                              </div>
                            </div>
                            <div class="fileGridContent">
                              <div class="fileGridItem">
                                <div class="fileItemImg">
                                  <img class="iconImg" src="../../../images/fileIcon/folder.png" alt="folder">
                                </div>
                                <div class="fileItemTitle">
                                  <span>새 폴더</span>
                                  <span class="filetype"></span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle"></i>
                                </div>
                              </div>
                              <div class="fileGridItem selected">
                                <div class="fileItemImg">
                                  <img src="../../../images/fileIcon/js.png" alt="img">
                                </div>
                                <div class="fileItemTitle">
                                  <span>이미지임시체크</span>
                                  <span class="filetype">.jpg</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle-fill"></i>
                                </div>
                              </div>
                              <div class="fileGridItem">
                                <div class="fileItemImg">
                                  <img src="../../../images/fileIcon/js.png" alt="img">
                                </div>
                                <div class="fileItemTitle">
                                  <span>이미지임시체크</span>
                                  <span class="filetype">.jpg</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle"></i>
                                </div>
                              </div>
                              <div class="fileGridItem selected">
                                <div class="fileItemImg">
                                  <img class="iconImg" src="../../../images/fileIcon/zip.png" alt="folder">
                                </div>
                                <div class="fileItemTitle">
                                  <span>압축파일</span><span class="filetype">.zip</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle-fill"></i>
                                </div>
                              </div>
                              <div class="fileGridItem ">
                                <div class="fileItemImg">
                                  <img class="iconImg" src="../../../images/fileIcon/html.png" alt="html">
                                </div>
                                <div class="fileItemTitle">
                                  <span>home</span><span class="filetype">.html</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle"></i>
                                </div>
                              </div>
                              <div class="fileGridItem ">
                                <div class="fileItemImg">
                                  <img class="iconImg" src="../../../images/fileIcon/excel.png" alt="excel">
                                </div>
                                <div class="fileItemTitle">
                                  <span>2025년도 2분기 재고현황</span><span class="filetype">.xlsx</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle"></i>
                                </div>
                              </div>
                              <div class="fileGridItem selected">
                                <div class="fileItemImg">
                                  <img class="iconImg" src="../../../images/fileIcon/pdf.png" alt="pdf">
                                </div>
                                <div class="fileItemTitle">
                                  <span>2025년 회사소개서</span><span class="filetype">.pdf</span>
                                </div>
                                <div class="checkBtn">
                                  <i class="bi bi-check-circle-fill"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>

                <!-- 하나라도 선택시 .active -->
                <div class="checkedFloatMsg active">
                  <span class="checkedMsg">3개 파일/폴더가 선택되었습니다.</span>
                  <span class="checkCancle">취소</span>
                </div>
                
</template>

<script>
import apiClient from "@/apiClient";

export default {
  props: ['projectId'],
  name: "ReportFile",
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],
    };
  },
  methods: {
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },    
    navigateProjectMenu(menu) {
      const nameMap = {
          //feed: 'ReportFeed',
          feed: 'ReportList',
          task: 'ReportTask',
          calendar: 'ReportCalendar',
          file: 'ReportFile'
      };

      if (nameMap[menu]) {
          this.$router.push({ name: nameMap[menu], params: { projectId: this.projectId } });
      } else {
          console.warn(`Unknown menu: ${menu}`);
      }
    },
    async getProjectInfo() {
      try {
        const response = await apiClient.post("/api/Project/project-info", {
          ProjectId: this.projectId,
        });

        if (response.status === 200) {
          const data = response.data;
          this.projectInfo = data.project || {};
          this.projectName = data.project.Name;
        }
      } catch (error) {
        console.error("Error fetching projectInfo data:", error);
      }
    },
  },
  mounted() {
    this.getProjectInfo();
  }
};
</script>

